import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DescodificadorService } from 'src/services/descodificador.service';
import { PermissoesService } from 'src/services/permissoes.service';
import { MessageService, ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-descodificador',
    templateUrl: './descodificador.component.html',
    styleUrls: ['./descodificador.component.scss'],
    standalone: false
})
export class DescodificadorComponent implements OnInit, AfterViewInit {
  data: any[] = [];
  form: FormGroup;
  displayModal: boolean = false;
  loading: boolean = false;
  dropDownTipoDescodificacao: any[] = [];
  dropDownEstacao: any[] = [];
  direitoInserir: boolean = false;
  direitoEditar: boolean = false;
  direitoExcluir: boolean = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';

  constructor(
    protected _formBuilder: FormBuilder,
    protected _descodificadorService: DescodificadorService,
    protected permissaoService: PermissoesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit(): void {
    this.direitoInserir = this.permissaoService.can('descodificadores_inserir');
    this.direitoEditar = this.permissaoService.can('descodificadores_editar');
    this.direitoExcluir = this.permissaoService.can('descodificadores_excluir');

    this.form = this._formBuilder.group({
      id: [null],
      descricao: [null],
      status: [null],
    })

    this.index()
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  index(){
    this._descodificadorService.index().subscribe(json => {
      this.data = json || [];
      setTimeout(() => {
        this.calculateScrollHeight();
      }, 200);
    })
  }

  openNew(){
    this.form.reset()
    this.displayModal = true
  }

  edit(event){
    this._descodificadorService.show(event.id).subscribe(json => {
      if(json.status == 0){
        this.form.get('status').setValue(true)
      } else {
        this.form.get('status').setValue(false)
      }
      this.form.patchValue(json); 
      this.displayModal = true;
      })
  }

  save(){
    let form = this.form.value;
    let params = {
      ...form,
      status: form.status ? 1 : 0,
    };    

    if (form.id == null) {
      this._descodificadorService.store(params).subscribe(json => {
          this.loading = false;
          this.index();
          this.displayModal = false;
      }, err => {
        this.loading = false;
      });
    } else {
      this._descodificadorService.update(params, form.id).subscribe(json => {
          this.loading = false;
          this.index();
          this.displayModal = false;
      }, err => {
        this.loading = false;
      });
    }
  }

  /**
   * Abre confirmação simples Sim/Não e, ao confirmar, chama DELETE /api/descodificacoes/{id}.
   * Documentação: hard delete, 204 sucesso, 404 não encontrado.
   */
  confirmarExclusao(descodificador: any): void {
    const descricao = descodificador.descricao || `ID ${descodificador.id}`;
    this.confirmationService.confirm({
      key: 'globalConfirm',
      message: `Deseja realmente excluir o descodificador "${descricao}" (código ${descodificador.id})?`,
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, excluir',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => this.excluirDescodificador(descodificador.id),
    });
  }

  private excluirDescodificador(id: number): void {
    this._descodificadorService.destroy(id).subscribe({
      next: () => {
        this.data = this.data.filter((item: any) => item.id !== id);
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Descodificador excluído com sucesso.',
        });
        setTimeout(() => this.calculateScrollHeight(), 200);
      },
      error: (err) => {
        const status = err?.status;
        const msg = err?.error?.message || 'Descodificador não encontrado.';
        if (status === 404) {
          this.data = this.data.filter((item: any) => item.id !== id);
          this.messageService.add({
            severity: 'warn',
            summary: 'Atenção',
            detail: msg || 'Descodificador não encontrado. Removido da lista.',
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: msg || 'Não foi possível excluir o descodificador.',
          });
        }
      },
    });
  }
}
